var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0625 13.0625V10.7625C30.0625 9.64239 30.0625 9.08234 29.8445 8.65452C29.6528 8.27819 29.3468 7.97223 28.9705 7.78049C28.5427 7.5625 27.9826 7.5625 26.8625 7.5625H10.1375C9.01739 7.5625 8.45734 7.5625 8.02952 7.78049C7.65319 7.97223 7.34723 8.27819 7.15549 8.65452C6.9375 9.08234 6.9375 9.64239 6.9375 10.7625V13.0625M30.0625 13.0625V23.6125C30.0625 24.7326 30.0625 25.2927 29.8445 25.7205C29.6528 26.0968 29.3468 26.4028 28.9705 26.5945C28.5427 26.8125 27.9826 26.8125 26.8625 26.8125H10.1375C9.01739 26.8125 8.45734 26.8125 8.02952 26.5945C7.65319 26.4028 7.34723 26.0968 7.15549 25.7205C6.9375 25.2927 6.9375 24.7326 6.9375 23.6125V13.0625M30.0625 13.0625H6.9375",
    stroke: "#DADADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1035 4.8125L13.1035 10.3125M23.8952 4.8125L23.8952 10.3125",
    stroke: "#DADADA",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23.375L18.5 16.5",
    stroke: "#DADADA",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3535 19.9375L14.6452 19.9375",
    stroke: "#DADADA",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOutlined);
export default __webpack_public_path__ + "static/media/calendar-outlined.68fc1c53b27597b147e129f4cb1b408f.svg";
export { ForwardRef as ReactComponent };